import React from "react";
import dayjs from "dayjs";
import { Button, Stack } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";

const toDayjs = (value) => {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

const DateRangeFilter = ({ startDate, endDate, onDateChange, applyFilters }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack
        direction="row"
        spacing={1.25}
        alignItems="center"
        justifyContent="flex-end"
        flexWrap="wrap"
        useFlexGap
        sx={{ mb: 2.5 }}
      >
        <DatePicker
          label="Start Date"
          value={toDayjs(startDate)}
          onChange={(newDate) =>
            onDateChange("startDate", newDate?.isValid?.() ? newDate.toDate() : null)
          }
          maxDate={dayjs()}
          slotProps={{
            textField: {
              size: "small",
              sx: { width: { xs: "100%", sm: 168 } },
            },
          }}
        />

        <DatePicker
          label="End Date"
          value={toDayjs(endDate)}
          onChange={(newDate) =>
            onDateChange("endDate", newDate?.isValid?.() ? newDate.toDate() : null)
          }
          maxDate={dayjs()}
          slotProps={{
            textField: {
              size: "small",
              sx: { width: { xs: "100%", sm: 168 } },
            },
          }}
        />

        <Button
          variant="contained"
          size="small"
          onClick={applyFilters}
          sx={{
            whiteSpace: "nowrap",
            height: 40,
            px: 2,
            flexShrink: 0,
          }}
        >
          Apply Filter
        </Button>
      </Stack>
    </LocalizationProvider>
  );
};

export default DateRangeFilter;
